import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import TelerikDataTable from "../../../../CommonComponents/TelerikDataTable/indexV2";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
import useSortedColumns from "../../../../utils/useSortedColumns";
import AdvanceSearch from "../../../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../../../ErrorBoundry";
import visileColumns from "./visibleColumns";
import {
  Autocomplete,
  Chip,
  createFilterOptions,
  Radio,
  TextField,
} from "@mui/material";
import EligibilityTable from "../Eligibility/EligibilityTable";
import CustomizerContext from "../../../../_helper/Customizer";
import { post, get } from "../../../../_helper/api_helper";
import { ShowError, ShowSucess } from "../../../../_helper/helper";
import { advanceSearch } from "../../../../_helper/services/advanceSearchv2";
import axios from "axios";
import { getFormalApiErrorMessage } from "../../../../utils/apiError";

function ApplicantsTable({ setSubstepes = null }) {
  const location = useLocation();
  const { state } = location;
  const id = "APPLICANTS";
  const {
    setEligibilityTableShow,
    singleEligibilityList,
    EligibilityTableShow,
    allApplicantsData,
  } = useContext(CustomizerContext);
  const ANNOUNCEMENT_ID_Value = useMemo(() => {
    const { ANNOUNCEMENT_ID } = EligibilityTableShow;
    if (ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim();
    return "";
  }, [EligibilityTableShow]);

  const AllElgIdsPayload = useMemo(() => {
    if (allApplicantsData && allApplicantsData.length > 0) {
      return allApplicantsData.map((item) => item?.eligibility_id.trim());
    }
    return [];
  }, [allApplicantsData]);

  const AllElgIdsPayloadString = useMemo(
    () => (AllElgIdsPayload.length > 0 ? JSON.stringify(AllElgIdsPayload) : ""),
    [AllElgIdsPayload]
  );
  const dispatch = useDispatch();
  const history = useNavigate();
  const {
    columns,
    loadingSearch,
    ColumnsSorted,
    searchParameter,
    searchResultsV2,
    error,
    currentID,
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const { results, rowCount } = useMemo(() => {
    const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
    return {
      results: searchResult.results,
      rowCount: searchResult.rowCount,
    };
  }, [searchResultsV2[id], id]);
  const { userData } = useAuth();
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const { filter: storeFilter, pageSize: storePageSize } = useSelector(
    (state) => state.CommonReducer
  );
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const { sort } = useSelector((state) => state?.CommonReducer) || {};
  const [sortData, setSortData] = useState([
    { field: "evaluation_rating", dir: "desc" },
  ]);
  const [searchParams, setSearchParams] = useState([
    {
      columnName: "announcement_id",
      value: ANNOUNCEMENT_ID_Value,
      operator: "=",
      dataType: "varchar(50)",
      logicOperator: "AND",
    },
    {
      columnName: "eligibility_list",
      value:
        AllElgIdsPayload.length == 1
          ? AllElgIdsPayload[0]
          : AllElgIdsPayload.join(","),
      operator: "=",
      dataType: "varchar(500)",
      logicOperator: "AND",
    },
  ]);
  const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
  const [deleteData, setDeleteData] = useState(null);
  const [gg1ExportParams, setGG1ExportParams] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [modal, setModal] = useState(false);
  const [jobOpenings, setJobOpenings] = useState(0);
  const [responseDay, setResponseDay] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [notifyFive, setNotifyFive] = useState(true);
  const [hasShownApiError, setHasShownApiError] = useState(false);
  const [gg1ConfirmationModal, setGg1ConfirmationModal] = useState(false);

  // const [departmentDevData, setDepartmentDevData] = useState({
  //   data: [],
  //   isLoading: true,
  // });
  const [departments, setDepartments] = useState({ data: [], isLoading: true });
  const [divisions, setDivisions] = useState({ data: [], isLoading: false });
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [comments, setComments] = useState("");
  const [gg1Options, setGg1Options] = useState({ data: [], isLoading: false });
  const [selectedGG1, setSelectedGG1] = useState([]);
  const { postingResult, loading } = useSelector(
    (state) => state.JobAnnouncementReducer
  );

  // useEffect(() => {
  //   const getDepartmentDev = async () => {
  //     try {
  //       const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
  //       const response = await axios.post(
  //         `${newBaseURL}/AdvanceSearch/global`,
  //         {
  //           tableName: "LK_DPDV",
  //           searchParams: "[]",
  //           columns: "distinct DEPT_KEY,NAME,Dept_Code,DepartmentName",
  //           pageNumber: 1,
  //           pageSize: 10000000,
  //           orderBy: "DEPT_KEY",
  //           sortBy: "desc",
  //           orderByMultiple: "",
  //           limit: 10000000000,
  //           sortData: "",
  //           additionalWhere: "",
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${sessionStorage.getItem(
  //               "jwt_access_token"
  //             )}`,
  //           },
  //         }
  //       );
  //       setDepartmentDevData({ data: response.data.results, isLoading: false });
  //     } catch (err) {
  //       console.warn("Cannot retrieve department/division data", err);
  //       setDepartmentDevData({ data: [], isLoading: false });
  //     }
  //   };

  //   getDepartmentDev();
  // }, []);

  // This function will run once on component load
  const getDepartments = async () => {
    try {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const response = await axios.post(
        `${newBaseURL}/AdvanceSearch/global`,
        {
          tableName: "LK_DPDV",
          searchParams: "[]",
          // Only get the columns you need for the department dropdown
          columns: "distinct Dept_Code, DepartmentName",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: "DepartmentName", // Sort by name
          sortBy: "asc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setDepartments({ data: response.data.results, isLoading: false });
    } catch (err) {
      console.warn("Cannot retrieve department data", err);
      ShowError(
        getFormalApiErrorMessage(
          err,
          "We are unable to retrieve department data at this time. Please try again shortly."
        )
      );
      setDepartments({ data: [], isLoading: false });
    }
  };

  // This function runs whenever a department is selected
  const getDivisions = async (departmentCode) => {
    if (!departmentCode) return; // Don't run if no code is provided

    setDivisions({ data: [], isLoading: true }); // Set loading state for divisions
    try {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const response = await axios.post(
        `${newBaseURL}/AdvanceSearch/global`,
        {
          tableName: "LK_DPDV",
          searchParams: "[]",
          // Get the columns you need for the division dropdown
          columns: "DEPT_KEY, NAME",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: "NAME",
          sortBy: "asc",
          // Filter by the selected department code
          additionalWhere: `Dept_Code = '${departmentCode}'`,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setDivisions({ data: response.data.results, isLoading: false });
    } catch (err) {
      console.warn("Cannot retrieve division data", err);
      ShowError(
        getFormalApiErrorMessage(
          err,
          "We are unable to retrieve division data at this time. Please try again shortly."
        )
      );
      setDivisions({ data: [], isLoading: false });
    }
  };
  const getGG1Options = async (deptCode, announcementId) => {
    setGg1Options({ data: [], isLoading: true });
    try {
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const response = await axios.post(
        `${newBaseURL}/AdvanceSearch/global`,
        {
          tableName: "fn_GetGG1RecruitmentList",
          searchParams: `[{"columnName":"DeptCode","value":"${deptCode ?? ""}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"AnnouncementId","value":"${announcementId ?? ""}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
          columns: "*",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: 1,
          sortBy: "asc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setGg1Options({ data: response.data.results, isLoading: false });
    } catch (err) {
      console.warn("Cannot retrieve GG1 data", err);
      ShowError(
        getFormalApiErrorMessage(
          err,
          "We are unable to retrieve GG1 recruitment data at this time. Please try again shortly."
        )
      );
      setGg1Options({ data: [], isLoading: false });
    }
  };

  // This effect fetches the initial department list
  useEffect(() => {
    getDepartments();
  }, []);

  // This new effect watches for changes in the selected department
  // and fetches the corresponding divisions.
  useEffect(() => {
    if (selectedDepartment?.value) {
      getDivisions(selectedDepartment.value);
      getGG1Options(selectedDepartment.value, ANNOUNCEMENT_ID_Value);
    } else {
      setDivisions({ data: [], isLoading: false });
      setGg1Options({ data: [], isLoading: false });
      setSelectedGG1([]);
    }
  }, [selectedDepartment]);

  // const departmentOptions = useMemo(() => {
  //   if (departmentDevData.isLoading || !departmentDevData.data) return [];

  //   const uniqueDepartments = new Map();
  //   departmentDevData.data.forEach((item) => {
  //     if (
  //       !uniqueDepartments.has(item.Dept_Code) &&
  //       !!item.Dept_Code &&
  //       !!item.DepartmentName
  //     ) {
  //       uniqueDepartments.set(item.Dept_Code, {
  //         label: item.DepartmentName,
  //         value: item.Dept_Code,
  //       });
  //     }
  //   });
  //   return Array.from(uniqueDepartments.values());
  // }, [departmentDevData]);

  // const divisionOptions = useMemo(() => {
  //   if (
  //     !selectedDepartment ||
  //     departmentDevData.isLoading ||
  //     !departmentDevData.data
  //   ) {
  //     return [];
  //   }
  //   return departmentDevData.data
  //     .filter(
  //       (item) =>
  //         item.Dept_Code === selectedDepartment.value &&
  //         !!item.Dept_Code &&
  //         !!item.DepartmentName
  //     )
  //     .map((item) => ({
  //       label: item?.NAME,
  //       value: item?.DEPT_KEY,
  //     }));
  // }, [selectedDepartment, departmentDevData]);

  const departmentOptions = useMemo(() => {
    // Now reads from the clean 'departments' state
    return departments.data
      .filter((item) => item.Dept_Code && item.DepartmentName) // Basic validation
      .map((item) => ({
        label: `${item.DepartmentName.trim()}(${item.Dept_Code})`,
        value: item.Dept_Code.trim(),
        payloadlabel: item.DepartmentName.trim(),
      }));
  }, [departments.data]);

  const divisionOptions = useMemo(() => {
    // Now reads from the clean 'divisions' state
    return divisions.data
      .filter((item) => item.DEPT_KEY && item.NAME) // Basic validation
      .map((item) => ({
        label: `${item.NAME.trim()}(${item.DEPT_KEY})`,
        value: item.DEPT_KEY.trim(),
        payloadlabel: item.NAME.trim(),
      }));
  }, [divisions.data]);

  useEffect(() => {
    let temp = [
      {
        columnName: "announcement_id",
        value: ANNOUNCEMENT_ID_Value,
        operator: "=",
        dataType: "varchar(50)",
        logicOperator: "AND",
      },
      {
        columnName: "eligibility_list",
        value:
          AllElgIdsPayload.length == 1
            ? AllElgIdsPayload[0]
            : AllElgIdsPayload.join(","),
        operator: "=",
        dataType: "varchar(500)",
        logicOperator: "AND",
      },
    ];
    if (state?.notifyMore) {
      temp.push({
        columnName: "general_eligibility_id",
        value: state?.generalID,
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      });
    }
    setSearchParams([...temp]);
  }, [ANNOUNCEMENT_ID_Value, AllElgIdsPayloadString]);

  const actions = useMemo(() => {
    return [
      {
        title: "Select",
        icon: { iconName: "k-icon  k-i-radiobutton" },
        className: "font-primary",
        style: { cursor: "pointer" },
        action: (props) => {
          setEligibilityTableShow(props.dataItem);
        },
      },
    ];
  }, []);

  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);

  useEffect(() => {
    if (loadingSearch) {
      setHasShownApiError(false);
      return;
    }

    const requestFailed = Boolean(error?.message);
    const isCurrentScreenRequest = currentID === id;

    if (requestFailed && isCurrentScreenRequest && !hasShownApiError) {
      ShowError(
        "We are unable to load the applicants list at this time. Please try again shortly. If the issue persists, please contact your system administrator."
      );
      setHasShownApiError(true);
    }
  }, [loadingSearch, error, currentID, id, hasShownApiError]);

  useEffect(() => {
    // Update state or perform actions based on postingResult and loading state
  }, [postingResult, loading]);

  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);

  const getViewRulesByAnnouncement = async () => {
    const payload = {
      tableName: "RULES",
      searchParams: "[]",
      columns: "*",
      location: "pmis-global",
      pageNumber: 1,
      pageSize: 100,
      sortData: "",
      additionalWhere: `JOB_TITLE_SHORT= '${EligibilityTableShow?.JOB_TITLE_SHORT?.trim()}' or JOB_TITLE_LONG='${EligibilityTableShow?.JOB_TITLE_SHORT?.trim()}'`,
      qID: 0,
    };
    try {
      const response = await advanceSearch(payload);
      if (response?.results) {
        const { rules } = response.results;
        if (rules === 10) setNotifyFive(false);
        else setNotifyFive(true);
      }
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to verify the applicable rules at this time. Please try again shortly."
        )
      );
    }
  };

  useEffect(() => {
    getViewRulesByAnnouncement();
  }, []);

  const [sortedColumns, setSortedColumns] = useState(visileColumns);

  // const [sortedColumns, setSortedColumns] = useSortedColumns(
  //     id,
  //     ColumnsSorted,
  //     [],
  //     visileColumns,
  //     userData
  // );

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };

  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    setPageSize(100);
  };

  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
    setPageSize(100);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  const toggleModal = () => setModal(!modal);
  const requiredGG1Count = Number(jobOpenings) || 0;
  const hasSelectedGG1 = selectedGG1.length > 0;
  const isGG1SelectionValid =
    !hasSelectedGG1 ||
    (requiredGG1Count > 0 && selectedGG1.length === requiredGG1Count);

  const submitWithoutGG1 = async () => {
    try {
      setSubmitLoader(true);

      // Step 1: Get auto-assigned HR control IDs
      const nrResponse = await get(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateNrHrControlIds?Noofvacancies=${Number(jobOpenings)}`,
        {}
      );
      const hrControls = Array.isArray(nrResponse?.hrcontrols)
        ? nrResponse.hrcontrols.join(",")
        : "";

      // Step 2: Submit with the auto-assigned HR controls
      const payload = {
        announcement_id: ANNOUNCEMENT_ID_Value,
        eligibility_list:
          AllElgIdsPayload.length == 1
            ? AllElgIdsPayload[0]
            : AllElgIdsPayload.join(","),
        applicant_to_include: state?.notifyMore
          ? Number(jobOpenings)
          : Number(jobOpenings) + 4,
        general_avaibility_id: state?.notifyMore ? state.AnnouncementID : "0",
        vacancy: Number(jobOpenings),
        department: selectedDepartment?.value,
        division: selectedDivision?.value,
        departmentName: selectedDepartment?.payloadlabel?.trim(),
        divisionName: selectedDivision?.payloadlabel?.trim(),
        comment: comments,
        hr_controls: hrControls,
        responseDay: Number(responseDay),
      };
      const response = await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateGeneralAvaibility`,
        payload
      );
      ShowSucess("Submitted successfully");
      if (setSubstepes) {
        history(`/certification-details/${encodeURIComponent(ANNOUNCEMENT_ID_Value)}?gaId=${response?.[0]?.generaL_AVAILIBILITY_ID}&certPid=`);
      }
    } catch (error) {
      console.log(error?.message ?? "Something went wrong");
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to generate the General Availability list at this time. Please try again shortly."
        )
      );
    } finally {
      setSubmitLoader(false);
      setGg1ConfirmationModal(false);
      toggleModal();
    }
  };

  const submitGeneralAvailability = async () => {
    try {
      setSubmitLoader(true);
      const payload = {
        announcement_id: ANNOUNCEMENT_ID_Value,
        eligibility_list:
          AllElgIdsPayload.length == 1
            ? AllElgIdsPayload[0]
            : AllElgIdsPayload.join(","),
        applicant_to_include: state?.notifyMore
          ? Number(jobOpenings)
          : Number(jobOpenings) + 4,
        general_avaibility_id: state?.notifyMore ? state.AnnouncementID : "0",
        vacancy: Number(jobOpenings),
        department: selectedDepartment?.value,
        division: selectedDivision?.value,
        departmentName: selectedDepartment?.payloadlabel?.trim(),
        divisionName: selectedDivision?.payloadlabel?.trim(),
        comment: comments,
        hr_controls: selectedGG1.map((g) => g.value.HrControl).join(","),
        responseDay: Number(responseDay),
      };
      const response = await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateGeneralAvaibility`,
        payload
      );
      ShowSucess("Submitted succesfully");
      if (setSubstepes) {
        history(`/certification-details/${encodeURIComponent(ANNOUNCEMENT_ID_Value)}?gaId=${response?.[0]?.generaL_AVAILIBILITY_ID}&certPid=`);
        // setSubstepes && setSubstepes(1);
      }
    } catch (error) {
      console.log(error?.message ?? "Somethig went wrong");
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to generate the General Availability list at this time. Please try again shortly."
        )
      );
    } finally {
      setSubmitLoader(false);
      setGg1ConfirmationModal(false);
      toggleModal();
    }
  };

  const handleModalSubmit = async () => {
    if (!requiredGG1Count) {
      ShowError("Please enter number of vacancy greater than 0");
      return;
    }

    if (!Number(responseDay)) {
      ShowError("Please enter applicant response day limit greater than 0");
      return;
    }

    if (!hasSelectedGG1) {
      setGg1ConfirmationModal(true);
      return;
    }

    if (!isGG1SelectionValid) {
      ShowError(
        `Please select exactly ${requiredGG1Count} GG1 recruitment record(s). Currently selected: ${selectedGG1.length}`
      );
      return;
    }

    await submitGeneralAvailability();
  };

  const filterOptions = useMemo(
    () =>
      createFilterOptions({
        matchFrom: "any",
        stringify: (option) => option.label,
      }),
    []
  );


  return (
    <ErrorBoundary>
      <Fragment>
        <Container fluid={true}>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center">
                    <div className="w-100">
                      <h5 className="m-0">Applicants List</h5>
                      <div className="d-flex align-items-center gap-2 justify-content-end">
                        {/* <Button color="primary" onClick={toggleModal}>Get Data</Button> */}
                        <Button
                          color="primary"
                          className="ml-2"
                          onClick={() => {
                            // showAllApplicantsHandler()
                            // setShowAllApplicants(true)
                            toggleModal();
                          }}
                        >
                          {state?.notifyMore
                            ? "Notify More Applicants"
                            : "Generate General Availability List"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <div>
                    <TelerikDataTable
                      id={id}
                      pageNumber={page}
                      pageSize={pageSize}
                      totalCount={rowCount}
                      skip={(page - 1) * pageSize}
                      take={pageSize}
                      data={
                        results.map((item) => ({
                          ...item,
                          evaluation_rating:
                            item?.evaluation_rating?.toFixed(2) ?? 0,
                        })) || []
                      }
                      sortData={sortData}
                      tableName={"applicant-by-annountment-eligiblity"}
                      searchParams={searchParams}
                      additionalWhere={additionalWhere}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      selectedColumns={sortedColumns}
                      setSortedColumns={setSortedColumns}
                      loading={loadingSearch}
                      enableFooterCell={false}
                      dataLocation="pmis-global"
                    // actions={actions}
                    // setChooseFilterMethod={setChooseFilterMethod}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Number of Job Openings</ModalHeader>
          <ModalBody>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <Autocomplete
                options={departmentOptions}
                loading={departments.isLoading}
                filterOptions={filterOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedDepartment}
                onChange={(event, newValue) => {
                  setSelectedDepartment(newValue);
                  setSelectedDivision(null);
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                // loading={departmentDevData.isLoading}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Department"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {divisions.isLoading ? (
                            <Spinner size="sm" />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />

              <Autocomplete
                options={divisionOptions}
                filterOptions={filterOptions}
                loading={divisions.isLoading}
                getOptionLabel={(option) => option.label || ""}
                value={selectedDivision}
                onChange={(event, newValue) => {
                  setSelectedDivision(newValue);
                }}
                size="small"
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                disabled={!selectedDepartment}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Division"
                    variant="outlined"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {divisions.isLoading ? <Spinner size="sm" /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />

              <TextField
                id="jobOpeningsInput"
                type="number"
                label="Number Of Vacancies"
                value={jobOpenings}
                onChange={(e) => setJobOpenings(e.target.value)}
                placeholder="Enter number of Vacancies"
                variant="outlined"
                size="small"
                fullWidth
              />

              <TextField
                id="responseDayInput"
                type="number"
                label="Applicant Response Day Limit"
                required
                value={responseDay}
                onChange={(e) => setResponseDay(e.target.value)}
                placeholder="Enter number of Response Days"
                variant="outlined"
                size="small"
                fullWidth
              />
              {/* {jobOpenings > 0 && (
                <strong>
                  Minimum{" "}
                  {state?.notifyMore
                    ? Number(jobOpenings)
                    : Number(jobOpenings) + (notifyFive ? 4 : 9)}{" "}
                  applicants will be notified
                </strong>
              )} */}

              <Autocomplete
                multiple
                options={gg1Options.data.map((item) => ({
                  label: item.HrControl,
                  value: item,
                }))}
                loading={gg1Options.isLoading}
                filterOptions={filterOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedGG1}
                onChange={(event, newValue) => setSelectedGG1(newValue)}
                isOptionEqualToValue={(option, value) => option.value.HrControl === value.value.HrControl}
                size="small"
                disabled={!selectedDepartment}
                renderTags={() => null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select GG1 Recruitment"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
              {selectedGG1.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {selectedGG1.map((item) => (
                    <Chip
                      key={item.value.HrControl}
                      label={JSON.stringify(item.value?.HrControl)}
                      size="small"
                      onDelete={() =>
                        setSelectedGG1((prev) => prev.filter((g) => g.value.HrControl !== item.value.HrControl))
                      }
                    />
                  ))}
                </div>
              )}
              {requiredGG1Count > 0 && hasSelectedGG1 && !isGG1SelectionValid && (
                <div style={{ color: "#dc3545", fontSize: "12px" }}>
                  Please select exactly {requiredGG1Count} GG1 recruitment
                  record(s). Selected: {selectedGG1.length}
                </div>
              )}
              <TextField
                label="Comments"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={handleModalSubmit}
              disabled={jobOpenings == 0 || responseDay == 0 || submitLoader}
              style={{ display: "flex", gap: "2px" }}
            >
              {submitLoader && <Spinner size="sm" />}
              Submit
            </Button>{" "}
            <Button
              color="secondary"
              onClick={toggleModal}
              disabled={submitLoader}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={gg1ConfirmationModal}
          toggle={() => !submitLoader && setGg1ConfirmationModal(false)}
          centered
        >
          <ModalHeader toggle={() => !submitLoader && setGg1ConfirmationModal(false)}>
            Confirm Submission
          </ModalHeader>
          <ModalBody>
            You have not selected a Recruitment GG1, eventually a Recruitment GG1 must be assigned to initiate the Named GG1, which you can do later.
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={submitWithoutGG1}
              disabled={submitLoader}
            >
              Yes, Please Proceed
            </Button>
            <Button
              color="secondary"
              onClick={() => setGg1ConfirmationModal(false)}
              disabled={submitLoader}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    </ErrorBoundary>
  );
}

export default ApplicantsTable;
